import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import SubmitButton from '../buttons/SubmitButton';
import * as formStyles from '../styles/styles.module.scss';
import OutlinedTextField from '../textFields/OutlinedTextField';
import * as styles from './styles/styles.module.scss';

type Props = {
  applyHandler?(...args: unknown[]): unknown;
  changeHandler?(event: React.ChangeEvent<HTMLInputElement>): void;
  errorMessage?: ReactNode;
  expanded: boolean;
  isSuccess: boolean;
  removeHandler?(...args: unknown[]): unknown;
  value: string;
};

function CouponCode({ expanded, applyHandler, changeHandler, removeHandler, isSuccess, errorMessage, value }: Props) {
  if (expanded) {
    const applyButtonContent = !isSuccess ? (
      <SubmitButton handler={applyHandler} text={<FormattedMessage defaultMessage="Apply" />} variant="outline" />
    ) : (
      <SubmitButton handler={removeHandler} text={<FormattedMessage defaultMessage="Remove" />} variant="outline" />
    );

    return (
      <div className={styles.container}>
        <div className={formStyles.inputGroup}>
          <OutlinedTextField
            changeHandler={changeHandler}
            enterKeyHandler={applyHandler}
            errorMessage={errorMessage}
            isDisabled={isSuccess}
            isSuccess={isSuccess}
            label={<FormattedMessage defaultMessage="Coupon code" />}
            value={value}
          />
          {applyButtonContent}
        </div>
      </div>
    );
  }

  return null;
}

CouponCode.defaultProps = {
  applyHandler: () => {},
  removeHandler: () => {}
};

export default CouponCode;
